// src/components/common/MobileTabBar.tsx
import React from 'react';
import { NavLink } from 'react-router-dom';
import Icon from './Icon';
import { IconName } from '../../types';

const tabs: { to: string; label: string; icon: IconName; end?: boolean }[] = [
    { to: '/', label: '홈', icon: 'home', end: true },
    { to: '/welfare', label: '복지', icon: 'heart' },
    { to: '/search', label: '검색', icon: 'search' },
    { to: '/2026', label: '2026', icon: 'sparkle' },
    { to: '/2027', label: '2027', icon: 'chart' },
];

const MobileTabBar: React.FC = () => (
    <nav className="gh-tabbar" aria-label="모바일 주요 메뉴">
        {tabs.map(t => (
            <NavLink
                key={t.to}
                to={t.to}
                end={t.end}
                className={({ isActive }) => `gh-tabbar__item${isActive ? ' is-active' : ''}`}
            >
                <Icon name={t.icon} size={21} />
                {t.label}
            </NavLink>
        ))}
    </nav>
);

export default MobileTabBar;
